<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="street">
    <th mat-header-cell *matHeaderCellDef>{{ "street" | translate }}</th>
    <td mat-cell *matCellDef="let element">
      <b
        class="sub-title"
        matTooltip="{{ 'see-details' | translate }}"
        (click)="goToDetails(element)"
        >{{ element.street }} {{ element.streetNumber }}</b
      >
    </td>
  </ng-container>

  <ng-container matColumnDef="construction">
    <th mat-header-cell *matHeaderCellDef>
      {{ "year-of-building" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ getYear(element.construction) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="municipality">
    <th mat-header-cell *matHeaderCellDef>
      {{ "municipality" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.municipality.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="city">
    <th mat-header-cell *matHeaderCellDef>
      {{ "city" | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.municipality.city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <div class="actions-panel">
        <mat-icon
          color="primary"
          (click)="goToDetails(element)"
          matTooltip="{{ 'see-details' | translate }}"
          >info</mat-icon
        >
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: columnsToDisplay"
    class="example-element-row"
  ></tr>
</table>

<mat-paginator
  #paginator
  [length]="total"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="changePage($event)"
>
</mat-paginator>
